import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import classes from "../../styles/AddressPrint.module.scss";

function MutlipleAddresses(props) {
    const [addreses, setAddressData] = useState([]);

    const { selectedRows } = props;

    const getAddresesAndQrData = async (data) => {
        return { address: data.address }
    }

    useEffect(() => {
        (async () => {
            let addreses = await Promise.all(
                props.addresses.map(async (data) => {
                    const row = selectedRows?.find((row) => row?.orderId === data.orderId || row?.id === data.orderId) || {}
                    const addressAndQrData = await getAddresesAndQrData(data);

                    const userNumber = row?.mapUserPatient?.User?.contact_no || ""
                    const patientNumber = row?.mapUserPatient?.Patient?.contact_no || ""
                    const addressNumber = addressAndQrData?.address?.phone || ""

                    const uniqueSet = new Set([userNumber, patientNumber, addressNumber]);
                    uniqueSet.delete("");

                    return { ...addressAndQrData, orderId: data.orderId, bill_no: data.bill_no, phoneString: Array.from(uniqueSet).join(",") }
                })
            )
            setAddressData(addreses)
        })()
    }, [])
    return (
        <div className={classes.Container} >
            {
                addreses.map((data, ind) => {
                    return (
                        <>
                            {data?.address && <div key={ind}>
                                <div id="section-to-print" className='flex flex-row gap-1 w-full justify-start items-start'>
                                    <div className='uppercase w-full'>
                                        <h3 className='!text-[15px]'>To,</h3>
                                        <div className='w-[100%] flex flex-col gap-2 mt-2'>
                                            <div className='flex flex-col gap-2 w-full font-semibold flex-1'>
                                                <div className='flex flex-row items-center w-full'>
                                                    <h5 contentEditable="true" className='text-[15px] flex-1'>NAME: &nbsp; {data?.address ? data?.address?.name?.toUpperCase() : ""}</h5>
                                                    <h5 className='text-[15px] whitespace-nowrap ml-4'>ORDER ID: &nbsp; {data?.orderId || ""}</h5>
                                                </div>
                                                <div className='flex flex-row items-center w-full'>
                                                    <h5 className='text-[15px] flex-1'>PHONE: &nbsp; {data?.phoneString ? data?.phoneString : data?.address ? data?.address?.phone : ""}</h5>
                                                    {data?.bill_no && <h5 className='text-[15px] whitespace-nowrap ml-4'>BILL NO: &nbsp; {data.bill_no}</h5>}
                                                </div>
                                            </div>
                                            <div className='w-[400px] flex text-[15px] flex-row font-semibold flex-1'>
                                                <h5>ADDRESS:  &nbsp;{data?.address?.line ? `${data?.address?.line} ` : ''}
                                                    {data?.address?.district ? `${data?.address?.district} ` : ''}
                                                    {data?.address?.state ? `${data?.address?.state} ` : ''}
                                                    {data?.address?.pincode ? data?.address?.pincode : ''}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            <br />
                        </>
                    )
                })
            }

        </div >
    )
}

export default MutlipleAddresses

MutlipleAddresses.propTypes = {
    addresses: PropTypes.any,
    selectedRows: PropTypes.any
}